'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/BackOffice'

import CreationForm from '@/Form/CreationForm'

import { form as _config } from '@Config/Tutorial/tutorial'

let config = _.cloneDeep(_config);

const { app } = window;

export default class NewTutorialPage extends Component
{
	state = { };

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const output =
		(
			<Layout page_title="Nouveau tutoriel" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="page-form-container">

							<CSSTransition classNames="a-form-transition"
								appear={ true } enter={ true } exit={ true }
								timeout={ { enter: 240, exit: 320, appear: 500 } }>

								<CreationForm config={ config } className="u-no-margin-top" />

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
